import {
  Alert,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Snackbar,
  Toolbar,
  Typography,
  useStepperContext,
} from "@mui/material";
import React, { useState } from "react";
import download from "downloadjs";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useDropzone } from "react-dropzone";
import CustomizedSnackbars from "../../components/200/CustomizedSnackbars";
import { CircularProgressWithLabel } from "../../components/200/CircularProgressWithLabel";

import { useTheme } from "@emotion/react";
// import api, { CancelToken, isCancel } from "../../api/PrivateApi";

import { useRef } from "react";

function ImportStaff({ close }) {
  let theme = useTheme();
  const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone();
  const [importError, setImportError] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [uploadPercent, setUploadPercent] = useState(0);
  const cancelFileUpload = useRef(null);

  const handleSubmit = () => {
    let formData = new FormData();
    formData.append("file", acceptedFiles[0]);
    formData.append("department", "office1");
    //axios
    //  .post("https://httpbin.org/anything", formData)
    //  .then((res) => console.log(res))
    //  .catch((err) => console.log(err));
    let option = {
      onUploadProgress: (progress) => {
        const { loaded, total } = progress;
        let percent = Math.floor((loaded * 100) / total);
        console.log(`${loaded} kb of ${total}kb | ${percent}`);
        setUploadPercent(percent);
      },
      // cancelToken: new CancelToken(
      //   (cancel) => (cancelFileUpload.current = cancel)
      // ),
    };
    // api
    //   .post("staff/upload", formData, option)
    //   .then((res) => {
    //     setImportError((prev) => {
    //       console.log(JSON.stringify(res.data, null, 2));
    //       return { open: true, message: res.data.message, type: "success" };
    //     });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     if (isCancel(err)) {
    //       console.log(err.message);
    //     } else {
    //       setImportError((prev) => {
    //         return {
    //           open: true,
    //           message: err.response.data?.message,
    //           type: "error",
    //         };
    //       });
    //     }
    // });
  };

  let cancelUpload = () => {
    if (cancelFileUpload.current) {
      cancelFileUpload.current("user has canceled the file upload");
    }
  };

  const files = acceptedFiles.map((file) => (
    <Box
      key={file.path}
      sx={{
        //border: "0.5px solid",
        //borderColor: "secondary.light",
        borderRadius: "0.6rem",
        //backgroundColor: "secondary.light",
        boxShadow: `1px 1px 2px ${theme.palette.third.main}`,
        padding: "0.8rem 0.8rem 0.8rem 0.8rem",
        display: "flex",
        alignItems: "center",
        //gap: "0.5rem",
        width: "100%",
        backgroundColor: uploadPercent === 100 ? "primary.light" : "white",
        margin: "1rem 0rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "20px",
          overflow: "hidden",
        }}
      >
        <InsertDriveFileIcon fontSize="medium" color="primary" />
        <Typography sx={{ width: "50%" }}>
          {" "}
          {file.path} - {file.size} bytes
        </Typography>
      </Box>
      {uploadPercent < 100 && (
        <CircularProgressWithLabel value={uploadPercent} />
      )}
    </Box>
  ));
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Toolbar
          sx={{
            borderBottom: "1px solid",
            borderColor: "third.light",
            padding: "0px",
          }}
        >
          <Typography flexGrow={1}>Import Courses</Typography>
          <IconButton onClick={() => close.setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <Container
          className="container"
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "0.1rem",
          }}
        >
          <Box
            sx={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.3rem",
            }}
          >
            <Typography variant="span" fontSize={"0.8rem"}>
              Download the sample document before importing.
            </Typography>
            <Button
              sx={{
                width: "100%",
                backgroundColor: "primary.lighter3",
                color: "teritiary.darker",
                display: "flex",
                justifyContent: "flex-start",
                gap: "0.5rem",
                "&:hover": {
                  backgroundColor: "secondary.lighter3",
                },
              }}
              onClick={() => {
                api
                  .get("http://localhost:5000/api/staff/download")
                  .then((res) => {
                    console.log(res);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
            >
              <Box
                flexGrow={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.4rem",
                }}
              >
                <InsertDriveFileIcon color="teritiary.dark" fontSize="medium" />
                <Typography
                  sx={{
                    fontWeight: 400,
                    textTransform: "none",
                    lineHeight: "16px",
                    fontSize: "0.8rem",
                  }}
                >
                  Download Sample
                </Typography>
              </Box>
              <FileDownloadIcon fontSize="large" color="secondary" />
            </Button>
            <Alert
              severity="info"
              color="secondary"
              sx={{ width: "100%", background: "none" }}
            >
              Allowed types: .csv, .xlsx
            </Alert>
          </Box>
          <Box
            {...getRootProps()}
            sx={{
              padding: "30px",
              border: "2px dashed",
              borderColor: "third.main",
              backgroundColor: "third.light",
            }}
          >
            <input {...getInputProps()} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CloudUploadIcon
                fontSize="large"
                sx={{ color: "primary.main" }}
              />
              <Typography
                variant="subtitle"
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  lineHeight: "20px",
                  textAlign: "center",
                }}
              >
                Drop you document here to start uploading
              </Typography>

              <Divider
                orientation="horizontal"
                flexItem
                sx={{
                  fontWeight: 600,
                  color: "third.dark",
                  padding: "0.5rem",
                }}
              >
                OR
              </Divider>
              <Button variant="outlined" color="secondary">
                Browse
              </Button>
            </Box>
          </Box>
          <Box>
            <h4>Files</h4>
            {files}
          </Box>
          <CustomizedSnackbars
            {...{
              snackBarOpen: importError.open,
              setSnackBarOpen: setImportError,
              message: importError,
            }}
          />
          <DialogActions sx={{ marginTop: "1.5rem" }}>
            <Button
              variant="outlined"
              color="third"
              onClick={() => {
                cancelUpload();
                close.setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
            >
              Import
            </Button>
          </DialogActions>
        </Container>
      </Box>
    </>
  );
}

export default ImportStaff;
